"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.putCoreSonarObjectsStakeholdersSlice = void 0;
const _api_1 = require("../../../api/index.js");
const get_1 = require("../../initiatives/summary/get.js");
const actions_1 = require("../_idMap/actions.js");
const xuder_1 = require("@sonar-software/xuder");
exports.putCoreSonarObjectsStakeholdersSlice = (0, xuder_1.createPutAsyncSlice)({
    additionalReceiveSteps: [
        {
            actionHandler: get_1.refreshCurrentInitiativeSummarySaga,
            type: xuder_1.SagaYieldType.Latest
        }
    ],
    httpSagaOptions: {
        successCombinationActionCreators: [
            (request) => (0, actions_1.updateSonarObjectReferences)([
                {
                    sonarObjectId: request.sonarObjectId,
                    stakeholders: request.stakeholderIds
                }
            ])
        ]
    },
    name: 'CoreSonarObjectsStakeholders',
    receive: false,
    request: true,
    requestHandler: _api_1.putSonarObjectStakeholders
});
//# sourceMappingURL=put.js.map